export const TABLET_WIDTH = 768;
export const DESKTOP_WIDTH = 1024;
export function isMobile() {
    return window.innerWidth < TABLET_WIDTH;
}
export function isTablet() {
    return window.innerWidth >= TABLET_WIDTH && window.innerWidth < DESKTOP_WIDTH;
}
export function isBelowDesktop() {
    return window.innerWidth < DESKTOP_WIDTH;
}
export function isDesktop() {
    return !isBelowDesktop();
}
/**
 * returns the device type based on window size
 * @returns {string} mobile|tablet|desktop
 */
export function getDeviceType() {
    return isMobile() ? 'mobile' : isTablet() ? 'tablet' : 'desktop';
}
export function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}
